import React, { useState } from 'react';
import { string, func, number } from 'prop-types';

import ModalInterior from '@alltrails/shared/components/ModalInterior';
import ModalBackground from '@alltrails/shared/components/ModalBackground';

import LanguageRegionCodePropType from '../../../proptypes/LanguageRegionCodePropType';
import { apiKey } from '../../../utils/lightbox_helpers';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import * as styles from './styles/styles.module.scss';
import { serverAjaxPromise } from '../../../utils/requests/request_helpers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const DeleteModal = ({ toggle, trackId, languageRegionCode, userSlug }) => {
  const [isSubmitting, setIsSubmitting] = useState();

  async function handleSubmit() {
    setIsSubmitting(true);

    try {
      const result = await serverAjaxPromise({
        type: 'DELETE',
        url: `/api/alltrails/maps/${trackId}?key=${apiKey}`
      });

      // this error case returns a 200 for the apps' sync sake, so look for whether to prompt the user in the JSON returned
      if (result && result.displayLifelinePrompt) {
        alert(StringConstantsMixin.strings.EDIT_RECORDING.THIS_MAP_IS_ASSOCIATED);
        setIsSubmitting(false);
      } else {
        const location = LanguageSupportUtil.wrapUrlSafe(`/members/${userSlug}/recordings`, languageRegionCode);
        window.location.assign(location);
      }
    } catch {
      const location = LanguageSupportUtil.wrapUrlSafe(`/members/${userSlug}/recordings`, languageRegionCode);
      window.location.assign(location);
    }
  }

  return (
    <ModalBackground closeModal={toggle} goBack={null}>
      <ModalInterior
        title={StringConstantsMixin.strings.EDIT_RECORDING.ARE_YOU_SURE}
        closeModal={toggle}
        isMounted
        baseCtas={{
          primaryCta: {
            onClick: handleSubmit,
            children: StringConstantsMixin.strings.EDIT_RECORDING.OK,
            disabled: isSubmitting
          },
          secondaryCta: {
            onClick: toggle,
            children: StringConstantsMixin.strings.CANCEL
          }
        }}
        goBack={null}
      >
        <div className={styles.deleteModalBody}>{StringConstantsMixin.strings.EDIT_RECORDING.ONCE_YOU_DELETE}</div>
      </ModalInterior>
    </ModalBackground>
  );
};

DeleteModal.propTypes = {
  languageRegionCode: LanguageRegionCodePropType.isRequired,
  toggle: func.isRequired,
  trackId: number.isRequired,
  userSlug: string.isRequired
};

export default DeleteModal;
